+function ($) {
    'use strict';

    var shadowMsg = function (element, option) {
        this.$element = $(element);
        this.duration = this.$element.data('duration');
        this.defaultDuration = 1500;
        if (!this.duration) {
            this.duration = this.defaultDuration;
        }
        var self = this;
        this.idTimeout = setTimeout(function() {
            self.hide();
        }, this.duration);
    };

    shadowMsg.prototype.hide = function () {
        var self = this;
        this.$element.animate({
            'opacity': 0
        }, {
            'duration': 600,
            'easing': 'swing',
            'complete': function () {
                clearTimeout(self.idTimeout);
                self.$element.css('display', 'none');
            }
        });
    };

    var constructor = function (options) {
        //вернуть надо объект jQuery
        return this.each(function () {
            return new shadowMsg(this, options)
        });
    };



    var old = $.fn.shadowMsg;

    $.fn.shadowMsg = constructor;
    $.fn.shadowMsg.constructor = constructor;

    $.fn.shadowMsg.noConflict = function () {
        $.fn.shadowMsg = old;
        return this;
    }
}(jQuery);